<template>
  <div>
    <!-- 操作按钮区域 -->
    <div class="table-operator" style="margin-bottom: 10px;">
      <a-button type="primary" icon="send" @click="handleInvoice" :disabled="invoiceList.length === 0">
        推送开票
      </a-button>
      <a-button icon="delete" @click="handleClear" :disabled="invoiceList.length === 0">
        清空列表
      </a-button>
    </div>

    <!-- 已选择信息 -->
    <div class="ant-alert ant-alert-info" style="margin-bottom: 10px;height: 40px;" v-if="invoiceList.length > 0">
      <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ invoiceList.length }}</a> 条业绩
      <span style="float:right; ">金额单位：元</span>
      <span style="float:right; margin-right:100px;">总佣金：{{ totalBrokerage }}</span>
      <span style="float:right; margin-right:100px;">总保费：{{ totalPremium }}</span>
    </div>

    <!-- table区域 -->
    <a-table
      v-if="invoiceList.length > 0"
      size="middle"
      :scroll="{ x: 3200, y: 700 }"
      bordered
      :rowKey="(record) => record.id || record.excelPolicy"
      :columns="columns"
      :dataSource="invoiceList"
      :pagination="false"
      class="j-table-force-nowrap">
      
      <template slot="statusSlot" slot-scope="text">
        <a-tag v-if="text=='0'" color="red">未提交</a-tag>
        <a-tag v-else-if="text=='1'" color="green">已确认</a-tag>
        <a-tag v-else-if="text=='2'" color="orange">已退回</a-tag>
        <a-tag v-else-if="text=='3'" color="blue">已匹配</a-tag>
        <a-tag v-else-if="text=='4'" color="purple">已提交</a-tag>
      </template>

      <template slot="colorSlot" slot-scope="text">
        <span>{{ !text ? '': Number(text).toLocaleString() }}</span>
      </template>

      <template slot="actionSlot" slot-scope="text, record">
        <a @click="handleRemove(record.id)">移除</a>
      </template>
    </a-table>

    <!-- 空状态 -->
    <div v-else style="text-align: center; padding: 80px 0; color: #999;">
      <a-icon type="inbox" style="font-size: 64px; color: #ddd;" />
      <p style="margin-top: 16px; font-size: 16px;">开票列表为空</p>
      <p style="margin-top: 8px; font-size: 14px; color: #999;">
        请从"条件查询开票"或"导入开票"页面添加业绩到开票列表
      </p>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import { postAction } from '@/api/manage'

  export default {
    name: 'BizDirectInvoiceList',
    data() {
      return {
        invoiceUrl: '/bms/invoiceOperation/pushInvoiceDirect',
        columns: [
          {
            title: '#',
            dataIndex: '',
            key: 'rowIndex',
            width: 60,
            fixed: 'left',
            align: "center",
            customRender: function(t, r, index) {
              return parseInt(index) + 1;
            }
          },
          {
            title: '业绩编号',
            className: 'column-text',
            align: "center",
            width: 200,
            fixed: 'left',
            dataIndex: 'businessNumber'
          },
          {
            title: '业绩状态',
            align: "center",
            width: 100,
            dataIndex: 'status',
            scopedSlots: { customRender: 'statusSlot' }
          },
          {
            title: '业务类型',
            className: 'column-text',
            align: "center",
            width: 100,
            dataIndex: 'businessType_dictText'
          },
          {
            title: '标的类型',
            className: 'column-text',
            align: "center",
            width: 100,
            dataIndex: 'productOrLife_dictText'
          },
          {
            title: '项目',
            className: 'column-text',
            align: "center",
            width: 280,
            dataIndex: 'project_dictText'
          },
          {
            title: '二级单位',
            className: 'column-text',
            align: "center",
            width: 180,
            dataIndex: 'insureParentOrg_dictText'
          },
          {
            title: '部门',
            className: 'column-text',
            align: "center",
            width: 100,
            dataIndex: 'sysOrgCode_dictText'
          },
          {
            title: '经纪人',
            className: 'column-text',
            align: "center",
            width: 100,
            dataIndex: 'createBy_dictText'
          },
          {
            title: '投保人',
            className: 'column-text',
            align: "center",
            width: 350,
            dataIndex: 'insure'
          },
          {
            title: '被保险人',
            className: 'column-text',
            align: "center",
            width: 350,
            dataIndex: 'insured'
          },
          {
            title: '保险人',
            className: 'column-text',
            align: "center",
            width: 350,
            dataIndex: 'insurerNumber_dictText'
          },
          {
            title: '险种类型',
            className: 'column-text',
            align: "center",
            width: 270,
            dataIndex: 'insuranceType_dictText'
          },
          {
            title: '险种名称',
            className: 'column-text',
            align: "center",
            width: 180,
            dataIndex: 'insuranceName'
          },
          {
            title: '车牌号',
            className: 'column-text',
            align: "center",
            width: 100,
            dataIndex: 'car'
          },
          {
            title: '保险起期',
            align: "center",
            width: 120,
            dataIndex: 'insuranceStart',
            customRender: function(text) {
              return !text ? '' : (text.length > 10 ? text.substr(0, 10) : text)
            }
          },
          {
            title: '保险讫期',
            align: "center",
            width: 120,
            dataIndex: 'insuranceEnd',
            customRender: function(text) {
              return !text ? '' : (text.length > 10 ? text.substr(0, 10) : text)
            }
          },
          {
            title: '保额',
            align: "center",
            width: 100,
            dataIndex: 'insuredAmount',
            className: 'column-money',
            customRender: function(text) {
              return !text ? '' : text.toLocaleString()
            }
          },
          {
            title: '费率',
            align: "center",
            width: 100,
            dataIndex: 'rate',
            customRender: function(text) {
              return !text ? '' : text + '%'
            }
          },
          {
            title: '保费',
            align: "center",
            width: 100,
            dataIndex: 'premium',
            className: 'column-money',
            customRender: function(text) {
              return !text ? '' : text.toLocaleString()
            }
          },
          {
            title: '净佣金',
            align: "center",
            width: 100,
            dataIndex: 'cleanPremium',
            className: 'column-money',
            customRender: function(text) {
              return !text ? '' : text.toLocaleString()
            }
          },
          {
            title: '是否含税',
            align: "center",
            width: 90,
            dataIndex: 'includeTax_dictText'
          },
          {
            title: '佣金比例',
            align: "center",
            width: 100,
            dataIndex: 'brokerageRatio',
            customRender: function(text) {
              return !text ? '' : text + '%'
            }
          },
          {
            title: '总保费',
            align: "center",
            width: 100,
            dataIndex: 'premium',
            className: 'column-money',
            customRender: function(text) {
              return !text ? '' : Number(text).toLocaleString()
            }
          },
          {
            title: '总佣金',
            align: "center",
            width: 100,
            dataIndex: 'brokerageTotal',
            className: 'column-money',
            scopedSlots: { customRender: 'colorSlot' }
          },
          {
            title: '期数',
            align: "center",
            width: 80,
            dataIndex: 'phase'
          },
          {
            title: '导入时间',
            align: "center",
            width: 120,
            dataIndex: 'createTime',
            customRender: function(text) {
              return !text ? '' : (text.length > 10 ? text.substr(0, 10) : text)
            }
          },
          {
            title: '确认时间',
            align: "center",
            width: 120,
            dataIndex: 'confirmTime',
            customRender: function(text) {
              return !text ? '' : (text.length > 10 ? text.substr(0, 10) : text)
            }
          },
          {
            title: '操作',
            align: "center",
            width: 80,
            fixed: 'right',
            scopedSlots: { customRender: 'actionSlot' }
          }
        ]
      }
    },
    computed: {
      ...mapGetters('invoice', ['invoiceList']),
      totalAmount() {
        return this.totalBrokerage
      },
      totalPremium() {
        if (!this.invoiceList || this.invoiceList.length === 0) return '0.00'
        let total = 0
        this.invoiceList.forEach(item => {
          if (item.premium) total += parseFloat(item.premium)
        })
        return total.toLocaleString()
      },
      totalBrokerage() {
        if (!this.invoiceList || this.invoiceList.length === 0) return '0.00'
        let total = 0
        this.invoiceList.forEach(item => {
          if (item.brokerageTotal) total += parseFloat(item.brokerageTotal)
        })
        return total.toLocaleString()
      }
    },
    methods: {
      ...mapActions('invoice', ['removeFromInvoiceList', 'clearInvoiceList']),
      handleRemove(id) {
        this.removeFromInvoiceList(id)
      },
      handleClear() {
        this.$confirm({
          title: '确认清空',
          content: '确定要清空开票列表吗？',
          onOk: () => {
            this.clearInvoiceList()
          }
        })
      },
      handleInvoice() {
        if (this.invoiceList.length === 0) {
          this.$message.warning('没有可开票的数据')
          return
        }
        
        let that = this
        this.$confirm({
          title: '确认开票',
          content: `已选择 ${this.invoiceList.length} 条业绩，总佣金 ${this.totalAmount} 元，确认开票？`,
          onOk() {
            that.doInvoice()
          }
        })
      },
      doInvoice() {
        let selectedIds = this.invoiceList.map(item => item.id).join(',')
        let idRelation = this.invoiceList.map(item => ({
          businessInfoId: item.id,
          insuranceBillId: ''
        }))

        let params = {
          idList: selectedIds,
          idRelation: idRelation
        }

        postAction(this.invoiceUrl, params).then((res) => {
          if (res.success) {
            this.$message.success('开票成功')
            this.clearInvoiceList()
            // 跳转到发票推送页面，查询当天数据
            this.$root.$emit('go-to-invoice-send')
          } else {
            this.$message.warning(res.message)
          }
        })
      }
    }
  }
</script>

<style scoped>
</style>
